import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import useStyles from './styles';

const SectionSeparator = (props: SectionSeparatorProps) => {
  const { classes } = useStyles();
  const { text, ...rest } = props;

  return (
    <Box width={'100%'} {...rest}>
      <Typography variant={'h6'} className={classes.textContent}>
        {text}
      </Typography>
      <Divider variant={'fullWidth'} className={classes.divider} />
    </Box>
  );
};

export interface SectionSeparatorProps extends BoxProps {
  text: string;
}

export default SectionSeparator;
